"use client";

import { Toolbar } from "@/components/ui/toolbar";

import { useAttentionCounts } from "../hooks/use-attention-counts";
import { COPY } from "../lib/copy";
import { AttentionBadge } from "./shared/attention-badge";
import { ConversationsFilterButton } from "./list/conversations-filter-button";
import { ConversationsTable } from "./list/conversations-table";

/**
 * Job-detail tab: no page header (the job header owns that), just the jobs-list
 * toolbar with the filter control and the attention count, then the table.
 */
export function JobScope({ jobId }: { jobId: string }) {
  const { total } = useAttentionCounts({ job_id: jobId });
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Toolbar.Container className="shrink-0">
        <ConversationsFilterButton />
        <div className="flex-1" />
        {total > 0 && (
          <div className="flex shrink-0 items-center gap-2">
            <span className="text-sm text-contrast/60">
              {COPY.columns.attention}
            </span>
            <AttentionBadge count={total} />
          </div>
        )}
      </Toolbar.Container>
      <ConversationsTable
        scope={{ job_id: jobId }}
        surface="job"
        emptyText={COPY.empty.job}
      />
    </div>
  );
}

export function CandidateScope({
  jobCandidateId,
}: {
  jobCandidateId: string;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg border border-border">
      <ConversationsTable
        scope={{ job_candidate_id: jobCandidateId }}
        surface="compact"
        emptyText={COPY.empty.candidate}
      />
    </div>
  );
}
